export enum WidgetTheme {
  Light = "light",
  Dark = "dark",
  Green = "green",
  Metal = "metal",
}

export const WidgetThemeName: Record<WidgetTheme, string> = {
  [WidgetTheme.Light]: "Legacy (light)",
  [WidgetTheme.Dark]: "Legacy (dark)",
  [WidgetTheme.Green]: "Inspire (green)",
  [WidgetTheme.Metal]: "Inspire (metal)",
};
